export default __webpack_public_path__ + "static/media/github.e0493221.svg";